import { ApiClient } from "../config/apiClient";

const BACKEND_URL = import.meta.env.VITE_GO_BACKEND_URL;

export const downloadZip = async (documentId: string): Promise<Blob> => {
  try {
    const axiosInstance = ApiClient.getInstance().getAxiosInstance();
    const response = await axiosInstance.get(
      `${BACKEND_URL}/download/${documentId}`,
      {
        responseType: "blob", // Important for handling binary data
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error downloading zip file:", error);
    throw error;
  }
};
